import ErrorSharpIcon from '@mui/icons-material/ErrorSharp';
import { Box, FormControl, TextField } from '@mui/material';
import { ChangeEvent, useState } from 'react';
import { ValidationError } from 'yup';
import useStore from '~/store';
import { Message } from '../types';
import { containerInput, containerMessage, inputStyle } from './styles';
import schema from './validation';

interface Props {
  content?: Message['content'];
  author?: Message['author'];
  Component?: Message['Component'];
  handleValidateInputs: (key: 'email' | 'name', isValid: boolean) => void;
}

export const InputEmail = ({ handleValidateInputs }: Props) => {
  const { quote, setEmail } = useStore((store) => ({
    quote: store.quote,
    setEmail: store.SetEmail
  }));
  const { email } = quote;

  const [error, setError] = useState(false);
  const [helperText, setHelperText] = useState('');

  const validateEmailValue = async (value: string) => {
    try {
      await schema.validate({
        email: value
      });
      setHelperText('');
      setError(false);
      handleValidateInputs('email', true);
    } catch (err) {
      if (err instanceof ValidationError) {
        setError(true);
        handleValidateInputs('email', false);
        setHelperText(err.message);
      }
    }
  };

  const handleChangeEmail = (event: ChangeEvent<HTMLTextAreaElement | HTMLInputElement>) => {
    const newEmailValue = event.target.value;

    setEmail(newEmailValue);
    validateEmailValue(newEmailValue);
  };

  return (
    <Box>
      <Box sx={() => containerMessage(error)}>
        <FormControl variant="outlined" sx={containerInput}>
          <TextField
            value={email}
            onChange={handleChangeEmail}
            error={error}
            helperText={helperText}
            type="email"
            variant="outlined"
            placeholder="Informe seu email"
            sx={inputStyle}
            InputProps={{
              endAdornment: error && <ErrorSharpIcon color="error" />
            }}
          />
        </FormControl>
      </Box>
    </Box>
  );
};
